import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";

export default function NotFound() {
  useSEO("Page introuvable", "Cette page n'existe pas.");

  return (
    <div className="pt-[140px] pb-40 max-w-[1300px] mx-auto px-6 lg:px-12 min-h-screen">
      <p className="label mb-8" style={{ color: "#C9A961" }}>Erreur 404</p>
      <h1
        className="font-serif mb-12"
        style={{ fontSize: "clamp(80px, 14vw, 200px)", lineHeight: 0.88, letterSpacing: "-0.03em", color: "#F8F6F0" }}
      >
        Page<br />introuvable.
      </h1>
      <p style={{ color: "rgba(248,246,240,0.6)", fontSize: 18, lineHeight: 1.75, maxWidth: 480, marginBottom: 48 }}>
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/home"
        className="label"
        style={{ color: "#C9A961", borderBottom: "1px solid #C9A961", paddingBottom: 4 }}
      >
        ← Retour à l'accueil
      </Link>
    </div>
  );
}
